const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Fire-and-forget private stat (listens, buy clicks) — survives page navigation.
export const trackEvent = (kind, name) => {
  try {
    const body = JSON.stringify({ kind, name });
    const url = `${BACKEND_URL}/api/stats/event`;
    if (navigator.sendBeacon) navigator.sendBeacon(url, new Blob([body], { type: "application/json" }));
    else fetch(url, { method: "POST", headers: { "Content-Type": "application/json" }, body, keepalive: true });
  } catch (e) { void e; }
};

export const retailerKey = (name) => {
  const n = (name || "").toLowerCase();
  if (n.includes("barnes")) return "barnes-noble";
  if (n.includes("kindle") || n.includes("amazon")) return "amazon-kindle";
  if (n.includes("readerdepot") || n.includes("audio")) return "readerdepot";
  if (n.includes("google")) return "google-books";
  return "secondary";
};
